var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18Next from "i18next";
import CustomCallbackBackend from "./i18next-callback-backend";
// Inspired from https://github.com/aurelia/i18n/blob/master/src/i18n.ts
export class FileeeClientI18N {
    constructor() {
        Object.defineProperty(this, "i18next", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "i18nextDeferred", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "Intl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.i18next = i18Next;
        this.i18nextDeferred = null;
        this.Intl = window.Intl;
        // @ts-ignore
        this.i18next.use(CustomCallbackBackend);
    }
    getI18n() {
        return this.i18next;
    }
    setup(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.i18nextDeferred = new Promise((resolve, reject) => {
                this.i18next.init(options, (err) => {
                    if (err && !Array.isArray(err)) {
                        reject(err);
                    }
                    resolve(this.i18next);
                });
            });
            return this.i18nextDeferred;
        });
    }
    i18nextReady() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.i18nextDeferred;
        });
    }
    loadNamespaces(namespace) {
        return new Promise((resolve, reject) => {
            this.i18next.loadNamespaces(namespace, (err) => {
                if (err) {
                    reject(err);
                }
                resolve();
            });
        });
    }
    setLocale(locale) {
        return new Promise((resolve, reject) => {
            this.i18next.changeLanguage(locale, (err, tr) => {
                if (err) {
                    reject(err);
                }
                resolve(tr);
            });
        });
    }
    getLocale() {
        return this.i18next.language;
    }
    nf(options, locales) {
        return new this.Intl.NumberFormat(locales || this.getLocale(), options || {});
    }
    df(options, locales) {
        return new this.Intl.DateTimeFormat(locales || this.getLocale(), options);
    }
    tr(key, options) {
        // @ts-ignore
        return this.i18next.t(key, options);
    }
}
//# sourceMappingURL=fileee-i18n.js.map